import { StringToBool } from "../utils/StringToBool.js";
import {
  enumUIModes,
  enumUISubModes,
  defaultRouteMode,
  isModeBackedByRuntime,
  isValidModeForRoute,
  kPositionID,
  kPositionTitleID
} from "../constants";
import { Globals } from "./Globals";
import { LocationSource } from "./LocationSource";

export class QUIConfig {
  constructor() {
    this.fWSMgr = null;
    this.fCanExportExcel = true;
    this.fCanExportGoogleSlides = false;
    this.fCanFilemgr = true;
    this.fCanPublish = true;
    this.fHasProfile = true;
    this.fEnableProfileStarring = true;
    this.fHasSubcharts = true;
    this.fHasSearch = true;
    this.fEnableBranding = true;
    this.fEnableAbout = true;
    this.fEnableHelp = { guide: true, support: true, terms: true }; //Set to true or false to hide or show. If strings, treat as hyperlinks (and enable). If the entire thing is set to false, don't show help.
    this.fEnableSignOut = true;
    this.fEnableMouseWheel = true;
    this.fDefaultLanguage = "en-US";
    this.fShowFilename = true;
    this.fDoHoverProfile = true;
    this.fDoAutoZoom = false;
    this.fEnableLanguage = true;
    this.fEnableGrid = false;
    this.fHadURLParams = false;
    this.fShowCurrentUser = true;
    this.fHasDirectory = true;
    this.fShowOverlay = true;
    this.fHasPlanning = true;
    this.fHasReporting = true;
    this.fHasManualChart = false;
    this.fEmployeelabelFields = ["Name", "Title"];
    this.fPositionLabelFields = [kPositionTitleID, kPositionID];
    this.fHasReportIssue = false;
    this.fHasWorkbench = true;
    this.fSelfLaunch = false;
    this.fBreadCrumbs = true;
    this.fRWUsersCanRefresh = false;
    this.fEnablePhotoSearch = true;
    this.fLaunchView = null;
    this.fInteractiveFields = true;
    this.fWebLinks = true;
    this.fRecordDetails = true;
    this.fChartExplorer = true;
    this.fModifyBackgrounds = true;
    this.fPositionMgmt = true;
    this.fBackgroundColor = null;
    this.fPrintPreview = null;

    this.fShowNotifications = true;

    this.fLaunchMode = null;
    this.fShowGrouping = false;
    this.fUiModeURLMap = {};
    this.fUiSubModeURLMap = {};
    this.fBLEHoverBarEnabled = true;
    this.fPackaging = true;
    this.fShareFilters = true;
    this.fEmbeddedMode = false;
    this.fFunctionalStatement = false;
    this.fChartNavigator = false;
    this.fSidebarFilters = true;
    this.fSidebarHighlights = true;
    this.fSidebarBackground = true;
    this.fSidebarEmployeeList = true;
    this.fHasSettings = true;
    this.fHasPIT = true;
    this.fPDFExportOnly = false;
    this.fHasViews = true;
    this.fHasNavigation = true;
  }

  //Set these defaults-  backwards compatibility
  //gUIConfig.fUIMode = enumUIModes.edit;
  //gUIConfig.fSubMode = enumWorkbenchUIModes.edit;
  loadUIProfile(newProfile) {
    for (var theSetting in newProfile) {
      var theValue = newProfile[theSetting];
      switch (theSetting) {
        case "profile":
          this.fHasProfile = theValue;
          break;
        case "profileStarring":
          this.fEnableProfileStarring = theValue;
          break;
        case "search":
          this.fHasSearch = theValue;
          break;
        case "subcharts":
          this.fHasSubcharts = theValue;
          break;
        case "excelExport":
          this.fCanExportExcel = theValue;
          break;
        case "googleSlidesExport":
          this.fCanExportGoogleSlides = theValue;
          break;
        case "fileManager":
          this.fCanFilemgr = theValue;
          break;
        case "canPublish":
          this.fCanPublish = theValue;
          break;
        case "branding":
          this.fEnableBranding = theValue;
          break;
        case "about":
          this.fEnableAbout = theValue;
          break;
        case "signoff":
          this.fEnableSignOut = theValue;
          break;
        case "help":
          this.fEnableHelp = theValue;
          break;
        case "defaultLanguage":
          this.fDefaultLanguage = theValue;
          break;
        case "showFilenames":
          this.fShowFilename = theValue;
          break;
        case "doHoverProfile":
          this.fDoHoverProfile = theValue;
          break;
        case "enableLanguage":
          this.fEnableLanguage = theValue;
          break;
        case "grid":
          this.fEnableGrid = theValue;
          break;
        case "showusername":
          this.fShowCurrentUser = theValue;
          break;
        case "directory":
          this.fHasDirectory = theValue;
          break;
        case "planning":
          this.fHasPlanning = theValue;
          break;
        case "reporting":
          this.fHasReporting = theValue;
          break;
        case "doReportIssue":
          this.fHasReportIssue = theValue;
          break;
        case "hasWorkbench":
          this.fHasWorkbench = theValue;
          break;
        case "selflaunch":
          this.SetIsSelfLaunch(theValue);
          break;
        case "breadCrumbs":
          this.fBreadCrumbs = theValue;
          break;
        case "positionMgmt":
          this.fPositionMgmt = theValue;
          break;
        case "fRWUsersCanRefresh":
          this.fRWUsersCanRefresh = theValue;
          break;
        case "photosearch":
          this.fEnablePhotoSearch = theValue;
          break;
        case "printpreview":
          this.fPrintPreview = theValue;
          break;
        case "employeeLabelFormat":
          this.fEmployeelabelFields = theValue;
          break;
        case "showGrouping":
          this.fShowGrouping = theValue;
          break;
        case "enableFields":
          this.fInteractiveFields = theValue;
          break;
        case "createWebLink":
          this.fWebLinks = theValue;
          break;
        case "recordDetails":
          this.fRecordDetails = theValue;
          break;
        case "chartExplorer":
          this.fChartExplorer = theValue;
          break;
        case "modifyBackgrounds":
          this.fModifyBackgrounds = theValue;
          break;
        case "packaging":
          this.fPackaging = theValue;
          break;
        case "shareFilters":
          this.fShareFilters = theValue;
          break;
        case "embeddedMode":
          this.fEmbeddedMode = theValue;
          break;
        case "functionalStatement":
          this.fFunctionalStatement = theValue;
          break;
        case "chartNavigator":
          this.fChartNavigator = theValue;
          break;
        case "sidebarFilters":
          this.fSidebarFilters = theValue;
          break;
        case "sidebarHighlights":
          this.fSidebarHighlights = theValue;
          break;
        case "sidebarBackground":
          this.fSidebarBackground = theValue;
          break;
        case "sidebarEmployeeList":
          this.fSidebarEmployeeList = theValue;
          break;
        case "settings":
          this.fHasSettings = theValue;
          break;
        case "pit":
          this.fHasPIT = theValue;
          break;
        case "pdfExportOnly":
          this.fPDFExportOnly = theValue;
          break;
        case "views":
          this.fHasViews = theValue;
          break;
        case "navigation":
          this.fHasNavigation = theValue;
          break;
      }
    }
  }

  GetIsSelfLaunch() {
    return this.fSelfLaunch;
  }

  GetPrintPreview() {
    return this.fPrintPreview;
  }

  GetBreadCrumbsEnabled() {
    return this.fBreadCrumbs;
  }

  GetPositionMgmtEnabled() {
    return this.fPositionMgmt;
  }

  SetIsSelfLaunch(isSelf) {
    this.fSelfLaunch = isSelf;
  }

  GetUIRoute(modeKey) {
    const routes = Object.keys(enumUIModes).map(key => key);
    return (
      routes.find(route => {
        return modeKey === route;
      }) || "chart"
    );
  }

  GetUIMode(url = LocationSource.getPathname(), search = LocationSource.getSearch()) {
    // Resource routes: mode comes from ?mode= query param, not the path.
    // /app/base/123?mode=edit → edit, /app/plan/456 → chart (default)
    const [, , segment] = url.split("/");
    if (segment in defaultRouteMode) {
      // Permission gating for /boxlayout/ and /plan/ lives in the route
      // definitions (PermissionGate in Root.tsx) — the gate blocks
      // rendering before the canvas ever mounts. GetUIMode is pure
      // structural mode resolution.
      var params = new URLSearchParams(search);
      var modeParam = params.get("mode");
      if (
        modeParam &&
        isValidModeForRoute(segment, modeParam, params) &&
        isModeBackedByRuntime(segment, modeParam, params, Globals._wsMgr)
      ) {
        return enumUIModes[this.GetUIRoute(modeParam)];
      }
      return defaultRouteMode[segment];
    }

    // Legacy mode routes: derive from path segment
    // Cache key includes only pathname (no query params) for legacy routes
    if (url in this.fUiModeURLMap) {
      return this.fUiModeURLMap[url];
    }

    if (!segment) {
      return enumUIModes.chart;
    }

    const key = this.GetUIRoute(segment);
    this.fUiModeURLMap[url] = enumUIModes[key];
    return enumUIModes[key];
  }

  GetUISubMode(url = LocationSource.getPathname()) {
    if (url in this.fUiSubModeURLMap) {
      return this.fUiSubModeURLMap[url];
    }

    // ['', 'app', UIMode, SubMode]
    const [, , , subMode] = url.split("/");

    if (!subMode) {
      return enumUISubModes.standard;
    }

    const routes = Object.keys(enumUISubModes).map(key => key);
    const key =
      routes.find(route => {
        return subMode === route;
      }) || "standard";

    this.fUiSubModeURLMap[url] = enumUISubModes[key];
    return enumUISubModes[key];
  }

  SetNewDocMode(mode) {
    this.fNewDocMode = mode; //
  }

  GetNewDocMode() {
    return this.fNewDocMode;
  }

  SetDocConfig(dir, file) {
    this.fDocConfig = { dir: dir, file: file };
  }

  GetDocConfig() {
    return this.fDocConfig;
  }

  ClearDocConfig() {
    this.fDocConfig = null;
  }

  SetChartOpenMode(mode) {
    this.fChartOpenMode = mode;
  }

  GetChartOpenMode() {
    return this.fChartOpenMode;
  }

  SetWorkbenchUIMode(subMode) {
    localStorage.stduimode = subMode;
    this.fSubMode = subMode;
  }

  InPortalMode() {
    var uiMode = this.GetUIMode();
    if (uiMode == enumUIModes.chart) return true;

    return false;
  }

  GetLaunchMode() {
    return this.fLaunchMode;
  }

  SetLaunchMode(mode) {
    this.fLaunchMode = mode;
  }

  InWorkbenchEditMode() {
    var stdMode = this.GetUIMode() == enumUIModes.edit && !Globals._accountInfo.ReadOnlyMode();
    return stdMode;
  }

  GetBackgroundColor() {
    return this.fBackgroundColor;
  }

  InEditMode() {
    const mode = this.GetUIMode();
    return (
      [enumUIModes.edit, enumUIModes.planning, enumUIModes.boxlayouteditor].includes(mode) ||
      this.InBackgroundEditorMode()
    );
  }

  InPlanningMode() {
    const mode = this.GetUIMode();
    return mode === enumUIModes.planning;
  }

  InChartKeyboardNavMode() {
    return this.GetUIMode() !== enumUIModes.edit && !this.InBackgroundEditorMode();
  }

  InBackgroundEditorMode() {
    if (new URLSearchParams(LocationSource.getSearch()).get("tool") !== "background") return false;
    if (!this.fWSMgr?.fPermissions?.canModifyBackgrounds?.()) return false;

    // Rule-driven (view-applied) backgrounds are immutable — the rule
    // engine reapplies on next view/subchart change, so the editor UI
    // (canvas margins, dotted lines, greyed boxes, ContextualToolbar's
    // background tools, PageProperties edit controls) is meaningless.
    // ?tool=background stays in the URL so the sidebar tab remains
    // available for viewing; this predicate answers "is the EDITOR
    // actually active", which is false when rules own the background.
    return !this.fWSMgr?.fBackgroundMgr?.IsViewAppliedBackground?.();
  }

  InBoxLayoutEditorMode() {
    const mode = this.GetUIMode();
    return mode === enumUIModes.boxlayouteditor;
  }

  GetSettingsPathName() {
    const [, , , mode] = LocationSource.getPathname().split("/");
    return mode;
  }

  GetAccountSettingsPathName() {
    const [, , , , mode] = LocationSource.getPathname().split("/");
    let modeName = undefined;
    if (mode != undefined) {
      switch (mode) {
        case "base-charts":
          modeName = "Base Charts";
          break;
        case "access-groups":
          modeName = "Access Groups";
          break;
        case "manage-users":
          modeName = "Manage Users";
          break;
        case "ui-profiles":
          modeName = "Manage Users";
          break;
        default:
          modeName = mode.slice(0, 1).toUpperCase() + mode.slice(1, mode.length);
          break;
      }
    }
    return modeName;
  }

  GetChartSettingsPathName() {
    const [, , , , , mode] = LocationSource.getPathname().split("/");
    let modeName = undefined;
    if (mode != undefined) {
      switch (mode) {
        case "data-source":
          modeName = "Data Source";
          break;
        case "search-directory":
          modeName = "Search & Directory";
          break;
        case "fields-formulas":
          modeName = "Fields & Formulas";
          break;
        case "import-filters":
          modeName = "Import Filters";
          break;
        case "point-in-time":
          modeName = "Point in Time";
          break;
        default:
          modeName = mode.slice(0, 1).toUpperCase() + mode.slice(1, mode.length);
          break;
      }
    }
    return modeName;
  }

  GetPlanSettingsPathName() {
    const [, , , , , mode] = LocationSource.getPathname().split("/");
    let modeName = undefined;
    if (mode != undefined) {
      switch (mode) {
        case "general":
          modeName = "General";
          break;
        default:
          modeName = mode.slice(0, 1).toUpperCase() + mode.slice(1, mode.length);
          break;
      }
    }
    return modeName;
  }

  GetDetailsPathName() {
    const [, , , mode] = LocationSource.getPathname().split("/");
    return mode;
  }

  ShowRightTabPanel() {
    var showTab;
    if (this.InPortalMode()) showTab = this.fShowTabs;
    else {
      showTab = true;
      var st = localStorage.showtab;
      if (st != null) showTab = StringToBool(st);
    }

    return showTab;
  }
}
